import { render, staticRenderFns } from "./dataKanban.vue?vue&type=template&id=a8cd8422&"
import script from "./dataKanban.vue?vue&type=script&lang=js&"
export * from "./dataKanban.vue?vue&type=script&lang=js&"
import style0 from "./dataKanban.vue?vue&type=style&index=0&id=a8cd8422&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports